import api from '@/lib/api';
import { useMutation } from '@tanstack/react-query';

export const useCreateSaveList = () => {
  return useMutation({
    mutationFn: (payload) =>
      api.publicationLists.create(payload).then((res) => res.data),
  });
};
